import React from 'react'
import Mainmenuitem from './mainmenuitem'
import '../../../css/components/admin/sidebar.css'
import {ReactComponent as HomeIcon} from '../../../images/icons/Dashboard.svg'
import {ReactComponent as ProductIcon} from '../../../images/icons/Listing.svg'
import {ReactComponent as StoreIcon} from '../../../images/admin/sidebar/store.svg'
import {ReactComponent as FilesIcon} from '../../../images/admin/sidebar/files.svg'
import {ReactComponent as AlgorithmIcon} from '../../../images/icons/Hashtag.svg'
import {ReactComponent as UserIcon} from '../../../images/icons/User_Active.svg'
import {ReactComponent as OrderIcon} from '../../../images/icons/Orders.svg'

const Index = () => {
  return (
    <div className='admin_sidebar_menuitems_container'>
      <Mainmenuitem title='Home' to='/admin/dashboard' Icon={HomeIcon} activeTarger='dashboard' listitems={null}/>
      <Mainmenuitem title='Products' to='/admin/products/category' activeTarger='products' Icon={ProductIcon} listitems={[
        {title:'Category',to:'/admin/products/category'},
        {title:'Color',to:'/admin/products/color'},
        {title:'Brand',to:'/admin/products/brand'},
        {title:'Condition',to:'/admin/products/condition'},
        {title:'Type',to:'/admin/products/type'},
        {title:'Listing Inactive',to:'/admin/products/listing/1'},
        {title:'Listing Active',to:'/admin/products/listing/2'},
        {title:'Collection',to:'/admin/products/collection'}
      ]}/>
      <Mainmenuitem title='Orders' to='/admin/orders' Icon={OrderIcon} activeTarger='orders' listitems={[
        {title:'List',to:'/admin/orders/list'},
        {title:'Discount Codes',to:'/admin/orders/discountcodes'}
      ]}/>
      <Mainmenuitem title='Algorithm' to='/admin/algorithm/intrust' activeTarger='algorithm' Icon={AlgorithmIcon} listitems={[
        {title:'Intrust',to:'/admin/algorithm/intrust'}
      ]}/>
      <Mainmenuitem title='User' to='/admin/user/list' activeTarger='user' Icon={UserIcon} listitems={[
        {title:'List',to:'/admin/user/list'},
        {title:'Location',to:'/admin/user/location'},
        {title:'Tickets',to:'/admin/user/tickets'}
      ]}/>
      <Mainmenuitem title='Online Store' to='/admin/onlinestore/navigation' activeTarger='onlinestore' Icon={StoreIcon} listitems={[
        {title:'Navigation',to:'/admin/onlinestore/navigation'},
        {title:'Pages',to:'/admin/onlinestore/pages'}
      ]}/>
      <Mainmenuitem title='Files' to='/admin/files' Icon={FilesIcon} activeTarger='files' listitems={null}/>
    </div>
  )
}

export default Index
